export const graphSidePanelContentIds = [
  'networkViewer',
  'compareSnapshot',
  'pathlookup',
  'intentVerification',
] as const;

export type GraphSidePanelContentId = (typeof graphSidePanelContentIds)[number];

export const isGraphSidePanelContentId = (
  value?: string | null,
): value is GraphSidePanelContentId =>
  graphSidePanelContentIds.includes(value as GraphSidePanelContentId);
